module.exports = __webpack_public_path__ + "static/finance-0c88b3712b6c5796f24eeb7854a9ab78.jpg";